import React from 'react';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Loader.css';

const Loader = ({
  message = '',
  secondaryMessage = '',
  showFONASUSpinner = false,
  smaller = false
}) => {
  return (
    <div
      className={cx(
        { 'transparent-outer-wrapper': showFONASUSpinner },
        { 'outer-wrapper': !smaller }
      )}>
      <div
        className={cx(
          { 'transparent-inner-wrapper': showFONASUSpinner },
          'inner-wrapper'
        )}>
        <h2 className="primary-message">{message}</h2>
        <p className="secondary-message" data-name="secondary-message">
          {parse(secondaryMessage)}
        </p>
        <div className="loader" />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

Loader.propTypes = {
  message: PropTypes.string,
  secondaryMessage: PropTypes.string,
  showFONASUSpinner: PropTypes.bool,
  smaller: PropTypes.bool
};

export default Loader;
